<template>
    <div class="mb-3">
        <div class="mt-3">
            <div class="mt-5 pb-2 border-b-2" style="border-style: dotted;">
                <Checkbox v-model="voice" @change="runPipeline" class="multiline-checkbox"><span class="checkbox-label">Deine Aufnahme abspielen<br><span class="small-price">(kostenlos)</span> <Popover text="Bei Aktivierung dieser Checkbox wird ein QR-Code auf dein Bild gedruckt. Diesen kannst du mithilfe deines Smartphones scannen, um so die zu Beginn bereits aufgenommene Botschaft (von max. 7 Sekunden) abzuspielen."></Popover></span></Checkbox>
            </div>
            <div class="mt-3">
                <Checkbox v-model="addExtraSound" @change="runPipeline" class="multiline-checkbox"><span class="checkbox-label">Zusätzliche Audio- oder Videobotschaft hinzufügen<br><span class="small-price">(zzgl. {{priceExtraSound.toFixed(2)}}€)</span> <Popover text="Hier kannst du, zusätzlich zu der zu Beginn aufgenommenen Sprachnachricht von 7 Sekunden eine weitere Audio- oder Videobotschaft hinzufügen. Auch wenn du mehrere QR-Code Optionen auswählst wird nur ein QR-Code auf deinem Bild gedruckt. Über diesen QR-Code können alle Botschaften abgespielt werden."></Popover></span></Checkbox>
            </div>
            <div v-show="addExtraSound">
                <AdditionalMessage></AdditionalMessage>
            </div>
            <div class="mt-3 pt-3 border-t-2" style="border-style: dotted;">
                <Checkbox v-model="digitalDownload" @change="setDigitalDownload" class="multiline-checkbox"><span class="checkbox-label">Digitaler Download<br><span class="small-price">(zzgl. 9,90 €)</span> <Popover text="Beim Anklicken dieser Checkbox erhältst du dein Stimmportrait zusätzlich als hochauflösende Datei zum downloaden. Damit hast du die Möglichkeit dein Kunstwerk auf Social Media zu teilen oder nochmal selbst auszudrucken."></Popover></span></Checkbox>
            </div>
            <div class="mt-5">
                <div class="label">QR-Code Position auswählen</div>
                <SelectBox v-model="position" @change="runPipeline(true)">
                    <option :selected="position === 'bottom-right'" value="bottom-right">Rechts unten</option>
                    <option :selected="position === 'bottom-left'" value="bottom-left">Links unten</option>
                    <option :selected="position === 'top-right'" value="top-right">Rechts oben</option>
                    <option :selected="position === 'top-left'" value="top-left">Links oben</option>
                </SelectBox>
            </div>
            <!-- <div class="mt-5">
                <Checkbox v-model="usePassword" class="multiline-checkbox"><span class="checkbox-label">Passwortschutz (optional)? <Popover text="Wenn du nicht möchtest, dass jeder deine persönliche Botschaft anhören kann, hast du die Möglichkeit den QR-Code mit einem Passwort zu versehen."></Popover></span></Checkbox>
            </div>
            <div class="mt-3 mb-3" v-if="usePassword">
                <input type="text" v-model="password" placeholder="Passwort festlegen">
            </div> -->
            <div class="mb-3">
                <TrustSymbols></TrustSymbols>
            </div>
            <!-- @click="toggleValue('qrcode.use', addQRCode)" -->
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import TrustSymbols from "./TrustSymbols.vue";
import Pipeline from "../../../Pipeline/Pipeline";
import defaults from '../../../Pipeline/_defaults';
import Popover from '~/scripts/Components/Popover.vue';
import AdditionalMessage from "./AdditionalMessage.vue";
import Checkbox from "~/scripts/Components/Checkbox.vue";
import SelectBox from "~/scripts/Components/SelectBox.vue";

export default {
    components: {
        Popover,
        Checkbox,
        SelectBox,
        TrustSymbols,
        AdditionalMessage
    },

    computed: {
        ...mapFields({
            size: 'qrcode.size',
            voice: 'qrcode.voice',
            addQRCode: 'qrcode.use',
            position: 'qrcode.position',
            password: 'qrcode.password',
            addExtraSound: 'extraSound.use',
            usePassword: 'qrcode.usePassword',
            digitalDownload: 'digitalDownload.use',
        })
    },

    data() {
        return {
            priceVoice: defaults.state.qrcode.price,
            priceExtraSound: defaults.state.extraSound.price
        }
    },

    methods: {
        runPipeline(positionChange = false) {
            const addQRCode = this.addQRCode;
            this.addQRCode = this.voice || this.addExtraSound;

            if (this.addQRCode != addQRCode || positionChange) {
                Pipeline.runQRCodePipeline();
                Pipeline.generateFinalImagePreview();
            }
        },

        setDigitalDownload() {
            this.$store.commit('updateField', {
                path: 'digitalDownload.use',
                value: this.digitalDownload
            });
        },
    },

    watch: {
        addExtraSound() {
            this.runPipeline(true);
        }
    }
};
</script>
